import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
 import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  TableContainer,
  Typography,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  colors,
  Switch,
  CircularProgress,
  Box,
} from '@material-ui/core';

import { Label,  TableEditBar } from '../../../../components';

const useStyles = makeStyles(theme => ({
  root: {},
  filterButton: {
    marginRight: theme.spacing(2)
  },
  content: {
    padding: 0
  },
  inner: {
  //  minWidth: 1150
  },
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end'
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(6),
  },
  nodataCont: {
    textAlign: 'center',
    padding: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
}));

const Results = props => {
  const {
    className,
    orders,
    loading,
    page,
    rowsPerPage,
    onPageChange,
    onPageLimit,
    onStatusupdate,
    ...rest
  } = props;

  const classes = useStyles();

  const [selectedOrders, setSelectedOrders] = useState([]);

  const handleSelectAll = event => {
    const selectedOrders = event.target.checked
      ? orders.map(order => order.id)
      : [];

    setSelectedOrders(selectedOrders);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrders.indexOf(id);
    let newSelectedOrders = [];

    if (selectedIndex === -1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders, id);
    } else if (selectedIndex === 0) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(1));
    } else if (selectedIndex === selectedOrders.length - 1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrders = newSelectedOrders.concat(
        selectedOrders.slice(0, selectedIndex),
        selectedOrders.slice(selectedIndex + 1)
      );
    }

    setSelectedOrders(newSelectedOrders);
  };

  const handleChangePage = (event, nextPage) => {
    onPageChange(nextPage);
  };
  const handleChange = orderindex => (event) => {

    onStatusupdate(orderindex,event.target.checked)
  };

  const handleChangeRowsPerPage = event => {
    onPageLimit(parseInt(event.target.value, 10));
  };

  const paymentStatusColors = {
    canceled: colors.grey[600],
    pending: colors.orange[600],
    active: colors.green[600],
    inactive: colors.red[600]
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
     
      <Card>
        <CardHeader
          
          title="Product"
        />
        <Divider />
        <CardContent className={classes.content}>
            <div className={classes.inner}>
            <TableContainer className={classes.container}>
              <Table>
                <TableHead>
                  <TableRow>
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedOrders.length === orders.length}
                        color="primary"
                        indeterminate={
                          selectedOrders.length > 0 &&
                          selectedOrders.length < orders.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell> */}
                    <TableCell>S no</TableCell>
                    <TableCell>Image</TableCell>
                    <TableCell>Commodity Name</TableCell>
                    <TableCell>Product Name</TableCell>
                    <TableCell>Language</TableCell>
                    <TableCell>Qty</TableCell>
                    <TableCell>status</TableCell>
					<TableCell>status</TableCell>
                    <TableCell>CreatedAt</TableCell>
                    
                    <TableCell align="center">Edit</TableCell>
                    
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <Box className={classes.loadingBox}>
                          <CircularProgress />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : orders.map((order, index) => (
                    <TableRow
                      key={order.id}
                      selected={selectedOrders.indexOf(order.id) !== -1}
                    >
                      {/* <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedOrders.indexOf(order.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, order.id)}
                          value={selectedOrders.indexOf(order.id) !== -1}
                        />
                      </TableCell> */}
                      <TableCell>
                      {page * rowsPerPage + (index + 1)}
                        
                      </TableCell>

                      <TableCell>                        
                        <Avatar alt={order.productname} src={`${order.imageurl}`} />
                      </TableCell>
                      <TableCell>
                        {order.product_commodities && order.product_commodities.map((role,index) => (
                         <> {role?.parent_commodity_id == null && 
                               <> <Label
                                color={paymentStatusColors[role.master_commodity?.name ? 'active' : 'inactive']}
                                variant="outlined"
                                >
                                {role?.master_commodity?.name ? role?.master_commodity?.name  : 'In Active'}
                                </Label>

                                {index % 4 && index > 0 ? <br></br> : null}</>
                         }</>
                               
                        ))}
                        

                      </TableCell>
                      <TableCell>{order.name}</TableCell>
                      <TableCell>
                        {order.product_languages && order.product_languages.map((role,index) => (
                          <>
                                <Label
                                color={paymentStatusColors[role.master_language?.name ? 'active' : 'inactive']}
                                variant="outlined"
                                >
                                {role?.master_language?.name ? role?.master_language?.name  : 'In Active'}
                                </Label>

                                {index % 4 && index > 0 ? <br></br> : null}
                                </>
                               
                        ))}
                        

                      </TableCell>
                      <TableCell>{order.qty}</TableCell>
                     
                      <TableCell>
                         <Label
                          color={paymentStatusColors[order.status ? 'active' : 'inactive']}
                          variant="contained"
                        >
                          {order.status ? 'Active' : 'In Active'}
                        </Label>

                      </TableCell>
					  <TableCell>
							<Switch size="small" color="primary" checked={order.status}
							      onChange={handleChange(index)}
							/>
                      </TableCell>
                      <TableCell>

                      <Typography variant="body1">
                          {moment(order.created_at).format(
                            'DD MMM YYYY hh:mm a' 
                          )}
                        </Typography>
                      </TableCell>
					
                      <TableCell align="center">
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={`/editproduct/${order.id}`}
                          variant="outlined"
                        >
                          Edit
                        </Button>
                      </TableCell>
                      
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

              {(!loading && orders.length === 0) ? (
                <Typography className={classes.nodataCont} component="h6">
                  No Records found
                </Typography>
              ) : null}
              </TableContainer>
            </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={props.totalcount}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
          />
        </CardActions>
      </Card>
      <TableEditBar selected={selectedOrders} />
    </div>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageLimit: PropTypes.func,
};

Results.defaultProps = {
  orders: [],
  loading: false,
  page: 0,
  rowsPerPage: 100,
};

export default Results;
